export default __webpack_public_path__ + "static/media/aboutimg6.4e743538.JPG";